import { useEffect, useState } from "react";
import { getAdminData, formatTalkTime } from "../../Utils/role";
import { getVendorSharedPlan } from "../../redux/services/SubscriptionServices/Subscription.Services";

export function readPlanBalance(response) {
  const sources = [response, response?.data, response?.data?.data, response?.plan];
  const source = sources.find(
    (item) => item && (item.seconds_limit != null || item.seconds_used != null)
  );
  if (!source) return null;
  return {
    limit: Number(source.seconds_limit) || 0,
    used: Number(source.seconds_used) || 0,
    left: Number(source.seconds_left) || 0,
  };
}

function SharedPlanBalance() {
  const [plan, setPlan] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const vendorId = getAdminData()?.user_id || "VND-330792";
    getVendorSharedPlan(vendorId)
      .then((response) => {
        const balance = readPlanBalance(response);
        if (!balance) {
          setFailed(true);
          return;
        }
        setPlan(balance);
      })
      .catch(() => setFailed(true));
  }, []);

  return (
    <div className="usage-block">
      <div className="usage-header-row">
        <span>Shared plan (work + investment)</span>
      </div>
      {failed && (
        <div className="usage-remaining">Talk time could not be loaded.</div>
      )}
      {plan && (
        <>
          <div className="usage-numbers">
            <div className="usage-big">
              {formatTalkTime(plan.used)}
              <div className="usage-split">of {formatTalkTime(plan.limit)}</div>
            </div>
          </div>
          <div className="usage-bar">
            <div
              className="usage-fill"
              style={{
                width: `${plan.limit ? Math.min(100, (plan.used / plan.limit) * 100) : 0}%`,
              }}
            />
          </div>
          <div className="usage-remaining">
            <span className="dot-green-sm" />
            {formatTalkTime(plan.left)} left
          </div>
        </>
      )}
    </div>
  );
}

export default SharedPlanBalance;
